import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { TableModule } from "primeng/table";
import { ConfirmationService } from "primeng/api";
import { CalendarModule } from "primeng/calendar";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { ColorPickerModule } from "primeng/colorpicker";
import { DropdownModule } from "primeng/dropdown";
import { CheckboxModule } from "primeng/checkbox";
import { AppSharedModule } from "../../shared/app-shared.module";
import { PersonSelectorModule } from "../personselector/personselector.module";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";
import { AccordionModule } from "primeng/accordion";

import { SchoolSettingsService } from "./services/adminsettings.service";
import { SchoolSettingsComponent } from "./components/adminsettings.component";
import { PeriodSettingsComponent } from "./periodsettings/periodsettings.component";
import { SchoolContactInfoComponent } from "./schoolcontactinfo/schoolcontactinfo.component";
import { SuspensionSettingsComponent } from "./suspensionsettings/suspensionsettings.component";
import { PreferenceSettingsComponent } from "./preferencesettings/preferencesettings.component";
import { ScanstationoptionsComponent } from "./preferencesettings/scanstationoptions/scanstationoptions.component";
import { SchoolemaildomainComponent } from "./preferencesettings/schoolemaildomain/schoolemaildomain.component";

import { TimeSetupComponent } from "./time-setup/time-setup.component";
import { SchoolGridComponent } from "./time-setup/school-grid/school-grid.component";
import { TimeSetupService } from "./time-setup/shared/data.service";
import { AcademyGridComponent } from "./time-setup/academy-grid/academy-grid.component";
import { GradeGridComponent } from "./time-setup/grade-grid/grade-grid.component";
import { HomeroomGridComponent } from "./time-setup/homeroom-grid/homeroom-grid.component";
import { StartPeriodGridComponent } from "./time-setup/start-period-grid/start-period-grid.component";
import { AdvancedPreferencesComponent } from "./advanced-preferences/advanced-preferences.component";
import { PrefsSchoolTableComponent } from "./advanced-preferences/prefs-school-table/prefs-school-table.component";
import { PrefsEmailTestComponent } from "./advanced-preferences/prefs-email-test/prefs-email-test.component";
import { PrefsCaassNotifySchoolTableComponent } from "./advanced-preferences/prefs-caass-notify-school-table/prefs-caass-notify-school-table.component";
import { DataService_AdvancedPreferences } from "./advanced-preferences/shared/data.service";
import { SUPreferenceSettingsComponent } from "./preferencesettings/supreference-settings/supreference-settings.component";
import { DigitalIdSettingsComponent } from "./digital-id-settings/digital-id-settings.component";
import { DigitalIdPbisSettingsComponent } from "./digital-id-settings/digital-id-pbis-settings/digital-id-pbis-settings.component";
import { DataService_DigitalID_Settings } from "./digital-id-settings/shared/data.service";
import { SemesterSetupComponent } from "./semester-setup/semester-setup.component";
import { PeriodSetupComponent } from "./period-setup/period-setup.component";

// import
// {
// 	SchoolSettingsService,
// 	SchoolSettingsComponent,
// 	PeriodSettingsComponent,
// 	SemesterSettingsComponent,
// 	SchoolContactInfoComponent,
// 	TimeSettingsComponent,
// 	SuspensionSettingsComponent,
// 	PreferenceSettingsComponent,
// 	ScanstationoptionsComponent,
// 	SupreferencesComponent,
// 	SchoolemaildomainComponent
// } from './index';

@NgModule({
	declarations: [
		SchoolSettingsComponent,
		PeriodSettingsComponent,
		SchoolContactInfoComponent,
		SuspensionSettingsComponent,
		PreferenceSettingsComponent,
		ScanstationoptionsComponent,
		SchoolemaildomainComponent,
		TimeSetupComponent,
		SchoolGridComponent,
		AcademyGridComponent,
		GradeGridComponent,
		HomeroomGridComponent,
		StartPeriodGridComponent,
		AdvancedPreferencesComponent,
		PrefsSchoolTableComponent,
		PrefsEmailTestComponent,
		PrefsCaassNotifySchoolTableComponent,
		SUPreferenceSettingsComponent,
		DigitalIdSettingsComponent,
		DigitalIdPbisSettingsComponent,
		SemesterSetupComponent,
		PeriodSetupComponent,
	],

	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		RouterModule,
		BrowserAnimationsModule,
		CalendarModule,
		ConfirmDialogModule,
		DialogModule,
		PersonSelectorModule,
		TableModule,
		CalendarModule,
		ColorPickerModule,
		DropdownModule,
		CheckboxModule,
		SchoolselectorModule,
		AccordionModule,
	],

	providers: [SchoolSettingsService, TimeSetupService, DataService_AdvancedPreferences, DataService_DigitalID_Settings],
})
export class SchoolSettingsModule {}
